import { COVER_PAGE_FRAMES } from './coverPage'

type FrameComponent = {
  classes?: string[]
  components?: FrameComponent[]
  attributes?: { id?: string }
  [key: string]: unknown
}

const remapIds = (component: FrameComponent): FrameComponent => {
  if (component.attributes?.id && typeof component.attributes.id === 'string') {
    component.attributes.id = component.attributes.id.replace(/^cover-page-v2/, 'cover-page-v3')
  }
  if (Array.isArray(component.components)) {
    component.components.forEach(remapIds)
  }
  return component
}

const cloneFrames = () => {
  const cloned = JSON.parse(JSON.stringify(COVER_PAGE_FRAMES))
  cloned.forEach((frame: { id: string; component: FrameComponent }) => {
    frame.id = frame.id.replace(/^cover-page-v2/, 'cover-page-v3')
    remapIds(frame.component)
  })
  return cloned
}

const addModernModifier = (frames: { component: FrameComponent }[]) => {
  const findContainer = (component: FrameComponent): FrameComponent | undefined => {
    if (component.classes?.includes('cover-page-v2__container')) {
      return component
    }
    if (Array.isArray(component.components)) {
      for (const child of component.components) {
        const found = findContainer(child)
        if (found) return found
      }
    }
    return undefined
  }

  for (const frame of frames) {
    const container = findContainer(frame.component)
    if (container?.classes && !container.classes.includes('cover-page-v2__container--modern')) {
      container.classes.push('cover-page-v2__container--modern')
    }
  }
}

const HOME_MODERN_FRAMES = (() => {
  const frames = cloneFrames()
  addModernModifier(frames)
  return frames
})()

export const HOME_MODERN_PAGE_ID = 'custom_home-modern'

export const HOME_MODERN_PAGE_DESIGN = {
  frames: HOME_MODERN_FRAMES,
  name: 'Cover Page Style 3',
  id: HOME_MODERN_PAGE_ID,
  type: 'main',
}
